<script setup lang="ts">
  import PosUiChip from '@/components/pos-v2/ui/PosUiChip.vue';
  import {
    ALLERGEN_CHOICES,
    hasAllergen,
    toggleAllergen,
  } from '@/domain/menu-import/item-editor';

  /**
   * «Alérgenos» of a dish (plan §4.5.1, D16): the 14 allergens as toggle
   * chips (dark when marked), labelled with the admin's `allergens.*` names
   * and in the order of `ALLERGENS`. Any change is a confirmation by the
   * owner (the API marks them confirmed).
   */
  const props = withDefaults(
    defineProps<{
      /** Bitmask of `ALLERGEN_BITS`. */
      value: number;
      /** Id of the visible label of the group. */
      labelledBy?: string;
    }>(),
    { labelledBy: undefined }
  );
  const emit = defineEmits<{ (e: 'input', bits: number): void }>();

  function toggle(bit: number) {
    emit('input', toggleAllergen(props.value, bit));
  }
</script>

<template>
  <div
    class="v2-menu-allergen-chips"
    role="group"
    :aria-labelledby="labelledBy"
  >
    <PosUiChip
      v-for="choice in ALLERGEN_CHOICES"
      :key="choice.bit"
      :active="hasAllergen(value, choice.bit)"
      @click="toggle(choice.bit)"
      >{{ $t(choice.labelKey) }}</PosUiChip
    >
  </div>
</template>

<style scoped lang="scss">
  // A wrapping row spaced with margins, not flex gap (old POS hardware,
  // Chrome < 84): 4px around each chip, absorbed by the negative margin.
  .v2-menu-allergen-chips {
    @apply tw--m-1 tw-flex tw-flex-wrap;

    > * {
      @apply tw-m-1;
    }
  }
</style>
